module.exports = __webpack_public_path__ + "img/thumb_image4.a59a4d2f.jpg";